import {
  Decoration,
  DecorationSet,
  EditorView,
  PluginValue,
  Range,
  ViewPlugin,
  ViewUpdate
} from "@uiw/react-codemirror";

interface VariableHighlightPluginValue extends PluginValue {
  decorations: DecorationSet;

  buildDecorations(view: EditorView): DecorationSet;
}

const variableHighlightMark = Decoration.mark({
  class: "variable-highlight",
  attributes: { "data-type": "variable" }
});

const removedVariableHighlightMark = Decoration.mark({
  class: "removed-variable-highlight blink",
  attributes: { "data-type": "removed-variable" }
});

const variableHighlightPluginClass = class
  implements VariableHighlightPluginValue
{
  decorations: DecorationSet;
  private view: EditorView;

  constructor(view: EditorView) {
    this.view = view;
    this.decorations = this.buildDecorations(view);
  }

  update(update: ViewUpdate) {
    if (update.docChanged || update.viewportChanged) {
      this.decorations = this.buildDecorations(update.view);
    }
  }

  destroy() {
    // Clean up resources
    this.decorations = Decoration.none;
    this.view = null!;
  }

  buildDecorations(view: EditorView): DecorationSet {
    try {
      const decorations: Range<Decoration>[] = [];
      const regex = /\$:var_[^!\s]+!/g;
      const removedVariableRegex = /\[removed variable\]/g;
      const text = view.state.doc.toString();

      let match;
      while ((match = regex.exec(text)) !== null) {
        const start = match.index;
        const end = start + match[0].length;
        decorations.push(variableHighlightMark.range(start, end));
      }

      while ((match = removedVariableRegex.exec(text)) !== null) {
        const start = match.index;
        const end = start + match[0].length;
        decorations.push(removedVariableHighlightMark.range(start, end));
      }

      return Decoration.set(decorations, true);
    } catch (error) {
      console.error("Error building decorations:", error);
      return Decoration.none;
    }
  }
};

export const variableHighlightPlugin = ViewPlugin.fromClass(
  variableHighlightPluginClass,
  {
    decorations: (v) => v.decorations
  }
).extension;
